import React from 'react';
import './header.css';
import BannerHome from '../../assets/banner_home.svg';
import BGHeader from '../../assets/bg-header.png';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <div className='gmc__header section__padding' id='home' style={{ 
      backgroundImage: `url(${BGHeader})` 
    }}>
      <div className='gmc__header-content'>
        <h1>Great Care <br/>Starts Here</h1>
        <p>Put the days of absenteeism from work due to caregiving behind you.<br /> Allow us to take the stress of care off you.</p>
        <Link to="/get-started" className='button__primary'>Find a Caregiver</Link>
      </div>
      <div className='gmc__header-image'>
        <img src={BannerHome} alt="Home"/>
        <div className='gmc__header-image-desc-1'>
          <p>We are fast changing the frontiers on home health in Africa</p>
        </div>

        <div className='gmc__header-image-desc-2'>
          <p>We care for your loved ones</p>
        </div>
      </div>
    </div>
  )
}

export default Header